import {SxProps} from '@mui/material';
import {COMMON_STYLES} from '../../constants/styles';

export const STYLES = {
  ...COMMON_STYLES,
  chartHeader: {
    gap: '13px',
    minHeight: '28px',
  },
  chartLegendHeader: {
    position: 'absolute',
    width: '350px',
    pl: '32px',
    pr: '20px',
    pb: '8px',
    top: '26px',
    right: '8px',
    height: '20px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#737373',
    borderBottom: '1px solid #E0E0E0',
  },
  chartContainer: {
    height: '100%',
    position: 'relative',

    '& .apexcharts-legend': {
      display: 'flex',
      mt: '32px',
      mb: '14px',
    },
    '& .apexcharts-legend-text': {
      width: '330px',
      display: 'flex',
      alignItems: 'center',
    },
  },
  buttonsContainer: {
    ml: 'auto',
    maxWidth: '400px',
  },
  chartLegendText: {
    fontWeight: 600,
    fontSize: '15px',
    lineHeight: '18px',
    textAlign: 'center',
    color: '#464255',
    width: 118,
  },
} as const satisfies SxProps;
